import React from "react";
import { Zap, ShieldCheck, Clock, Calendar } from "lucide-react";

const BENEFITS = [
  {
    icon: Zap,
    title: "Posters, banners, and signage on demand",
    body: "Print whatever your school needs, whenever you need it.",
  },
  {
    icon: ShieldCheck,
    title: "Durable, display-ready materials",
    body: "Laminated, finished, and built to last through the school year.",
  },
  {
    icon: Clock,
    title: "No outsourcing delays",
    body: "Skip the wait and cost of third-party print shops entirely.",
  },
  {
    icon: Calendar,
    title: "Long-term supply coverage",
    body: "1–2 years of ink, paper, and media included in the bundle.",
  },
];

export default function BundlesBenefits() {
  return (
    <section
      data-testid="bundles-benefits-section"
      className="bg-[#F4F6F4] py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="mb-14 max-w-3xl">
          <div className="text-xs uppercase tracking-[0.2em] font-bold text-teal mb-4">
            What this gives you
          </div>
          <h2
            data-testid="bundles-benefits-headline"
            className="font-serif text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-navy leading-tight"
          >
            Bring Printing{" "}
            <span className="text-teal">Fully In-House.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 lg:gap-6">
          {BENEFITS.map((b, i) => {
            const Icon = b.icon;
            return (
              <div
                key={b.title}
                data-testid={`bundles-benefit-${i}`}
                className="group flex items-start gap-5 bg-white border border-slate-200 hover:border-teal/40 rounded-2xl p-7 transition-all duration-300 hover:shadow-md"
              >
                <span className="flex-shrink-0 w-12 h-12 rounded-xl bg-navy text-white flex items-center justify-center group-hover:bg-teal transition-colors">
                  <Icon className="w-5 h-5" strokeWidth={2} />
                </span>
                <div>
                  <h3 className="font-serif text-lg sm:text-xl font-bold text-navy mb-2 leading-tight">
                    {b.title}
                  </h3>
                  <p className="text-sm text-slate-600 leading-relaxed">
                    {b.body}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
